import React from 'react';
import { Box, Typography, IconButton } from '@mui/material';
import { useParams, useNavigate } from 'react-router-dom';
import { ChevronLeft } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import DataAgentTabs from './DataAgentTabs';

const EditDataAgent: React.FC = () => {
  const { t } = useTranslation();
  const { dataAgentId } = useParams<{ dataAgentId: string }>();
  const navigate = useNavigate();

  return <DataAgentTabs entityType="edit" dataAgentId={dataAgentId} />;
};

export default EditDataAgent;
